import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8169236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropDown" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_svg = _resolveComponent("icon-svg")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, null, {
    overlay: _withCtx(() => [
      _createVNode(_component_a_menu, {
        class: "menu",
        onClick: _ctx.changeLang,
        selectedKeys: [_ctx.locale]
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (item) => {
            return (_openBlock(), _createBlock(_component_a_menu_item, { key: item }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  role: "img",
                  "aria-label": _ctx.languageLabels[item]
                }, _toDisplayString(_ctx.languageIcons[item]), 9, _hoisted_2),
                _createTextVNode(" " + _toDisplayString(_ctx.languageLabels[item]), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["onClick", "selectedKeys"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_icon_svg, { type: "language-outline" })
      ])
    ]),
    _: 1
  }))
}